export default "__VITE_ASSET__Dz$NmQub__"